import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type { ContractRouterClient } from "@orpc/contract";
import type { contract } from "./contract.js";

export type ApiClient = ContractRouterClient<typeof contract>;

export interface ClientOptions {
  /** e.g. "https://envstash.com" (no trailing slash). */
  origin: string;
  /** Bearer token for CLI/device sessions; browsers rely on the cookie instead. */
  token?: string;
  fetch?: typeof globalThis.fetch;
  headers?: () => Record<string, string>;
}

export function createClient(opts: ClientOptions): ApiClient {
  const link = new RPCLink({
    url: `${opts.origin}/rpc`,
    headers: () => ({
      ...(opts.token ? { authorization: `Bearer ${opts.token}` } : {}),
      ...(opts.headers?.() ?? {}),
    }),
    fetch: (url, init) =>
      (opts.fetch ?? globalThis.fetch)(url, {
        ...init,
        credentials: "include",
      }),
  });
  return createORPCClient(link);
}

export { isDefinedError, ORPCError, safe } from "@orpc/client";
